

import * as React from "react";
import { connect } from "react-redux";
import DatePicker from "../common/DatePicker";
import OpenSchedulingError from "./OpenSchedulingError";
import { Link } from "react-router-dom";
import MiniSpinner from "../common/MiniSpinner";
import MultiLineSelect from "../common/input/multiLineSelect";
import * as Tools from "../../helpers/Tools";
import { queryParams } from "../../helpers/formatting";
import { logUI } from "../../api/andyliticsApi";
import { get, startCase } from 'lodash';
import * as types from "../../constants/actionTypes";
import Spinner from "../common/spinner";
import * as queryString from 'query-string';


const DATE_FORMAT = Tools.getDateFormats();

class AppointmentInfo extends React.Component {
    constructor(props, context) {
        super(props, context);
        const { match } = this.props;
        let mammogramUrlParams = match && match.params && match.params.visitTypeId && match.params.visitTypeId.split(',');
        let twoDstateValue = mammogramUrlParams && mammogramUrlParams.length > 0 && mammogramUrlParams[0] === window.serverData.data.mammographyVisitTypeId ? window.serverData.data.mammographyVisitTypeId : "";
        let threeDStateValue = mammogramUrlParams && mammogramUrlParams.length > 0 && mammogramUrlParams[0] === window.serverData.data.mammography3DVisitTypeId ? window.serverData.data.mammography3DVisitTypeId : "";
        this.state = {
            textDisplay: false,
            twoDstate: twoDstateValue,
            threeDstate: threeDStateValue,
            isTwoDVisible: false,
            isToggle2D: false,
            fields: {
                visitType: '',
                location: '',
                dob: ''
            },
            notAvailableMsg: "",
            lastSelectedMonth: -1,
            validationError: "",
            showAsInvalid: false,
            nextStepCalled: false,
            monthChanged: false
        };

        this.mounted = false;
        this.twoDSlot = twoDstateValue;
        this.threeDSlot = threeDStateValue;
        this.monthName = "";

        this.handleVisitTypeChange = this.handleVisitTypeChange.bind(this);
        this.handleLocationchange = this.handleLocationchange.bind(this);
        this.formatSchedule = this.formatSchedule.bind(this);
        this.requestScheduleByMonth = this.requestScheduleByMonth.bind(this);
        this.checkStepChange = this.checkStepChange.bind(this);
        this.formatDate = this.formatDate.bind(this);
        this.parseDate = this.parseDate.bind(this);
        this.dateStringCompare = this.dateStringCompare.bind(this);
        this.containsDate = this.containsDate.bind(this);
        this.stupidDatePickerHack = this.stupidDatePickerHack.bind(this);
        this.getEndDate = this.getEndDate.bind(this);
        this.goToEarliestMonth = this.goToEarliestMonth.bind(this);
        this.selectedDayUnavailable = false;
        this.selectedTimeUnavailable = false;
        this.timeSelected = false;
    }

    componentDidMount() {
        logUI("MBHWeb.UI.AppointmentInfo.ComponentDidMount", new Date(), Tools.getURLPath());
        this.mounted = true;
        if (this.props.isMammography) {
            let mammogramUrlParams = this.props.match && this.props.match.params;
            if (this.props.isFromDotCOM) {
                let typeIds = mammogramUrlParams && mammogramUrlParams.visitTypeId.split(',');
                if (typeIds.length > 1) {
                    this.setState({
                        canShowTogglebutton: true,
                        twoDstate: window.serverData.data.mammographyVisitTypeId,
                        threeDstate: window.serverData.data.mammography3DVisitTypeId
                    })
                }

                if (typeIds[0].includes(window.serverData.data.mammographyVisitTypeId)) {
                    this.setState({
                        isTwoDVisible: true
                    })
                }
                else {
                    this.setState({
                        isTwoDVisible: false
                    })
                }
            }
            else {
                if (mammogramUrlParams && mammogramUrlParams.visitTypeId.split(',')) {
                    if (this.props.visitTypes.length === 1) {
                        if (this.props.visitTypes[0].value.trim(' ').includes(window.serverData.data.mammographyVisitTypeId)) {
                            this.setState({
                                isTwoDVisible: true
                            })
                        } else {
                            this.setState({
                                isTwoDVisible: false
                            })
                        }
                    } else {
                        this.setState({
                            isTwoDVisible: false
                        })
                    }
                }
                if (this.props.visit.visitType.id.split(',').length > 1) {
                    const visitTypeIds = this.props.visit.visitType.id.split(',');
                    const { serverData } = this.props;
                    const index2D = visitTypeIds.findIndex(ele => ele === serverData.mammographyVisitTypeId);
                    const index3D = visitTypeIds.findIndex(ele => ele === serverData.mammography3DVisitTypeId);
                    this.setState({
                        canShowTogglebutton: true,
                        twoDstate: this.props.visit.visitType.id.split(',')[index2D] + '|' + this.props.visit.visitType.idType,
                        threeDstate: this.props.visit.visitType.id.split(',')[index3D] + '|' + this.props.visit.visitType.idType
                    })
                } else if (mammogramUrlParams.visitTypeId.split(',').length > 1) {
                    this.setState({
                        canShowTogglebutton: true,
                        twoDstate: window.serverData.data.mammographyVisitTypeId,
                        threeDstate: window.serverData.data.mammography3DVisitTypeId
                    })
                }
                else if (this.props.visit.visitType.id === window.serverData.data.mammographyVisitTypeId) {
                    this.setState({
                        twoDstate: this.props.visit.visitType.id + '|' + this.props.visit.visitType.idType,
                    })
                } else {
                    this.setState({
                        threeDstate: this.props.visit.visitType.id + '|' + this.props.visit.visitType.idType,
                    })
                }
            }
        }
        this.componentDidUpdate();
    }

    componentDidUpdate(prevProps) {
        const { isFromDotCOM, isMammography,goToNewStep, visit,mammogramQuestions,hasMyChart,enableNewProviderSchedulingWorkflow } = this.props;
        if (this.props.visitTypeSelectedValue && !this.isYourDoctorVisitTypeUpdated && this.props.visitTypes.length > 0 && this.props.departments.length > 0) {//just check this incase of any default value other than initial default.
            this.isYourDoctorVisitTypeUpdated = true;
            this.handleVisitTypeChange(this.props.visitTypeSelectedValue);
        } 
        this.props.selectedDayUnavailable && this.props.selectedDayUnavailable(this.selectedDayUnavailable);
        this.props.selectedTimeUnavailable && this.props.selectedTimeUnavailable(this.selectedTimeUnavailable);
        this.props.isMonthChanged && this.props.isMonthChanged(this.state.monthChanged);

        if (isMammography && mammogramQuestions) {
            this.props.questionsCallBack(mammogramQuestions);
        }


        // debugger;
        // don't allow the user to proceed if we don't actually have schedule data.
        let canContinue = false;
        if (this.props.visit.date !== "" && this.props.visit.time !== "" && this.props.schedule && this.props.schedule.scheduleDays) {
            
            // scheduleDays[i].date = "2019-04-12"
            // props.visit.date     = "2019-4-12"
            // scheduleDays[i].slots[j].time = "13:00:00"
            // props.visit.time              = "13:00:00"
            let visitDt = new Date(this.props.visit.date);
            let dt = this.props.schedule.scheduleDays.find(d => {
                var date = new Date(d.date);
                return date.getFullYear() === visitDt.getFullYear() && date.getMonth() === visitDt.getMonth() && date.getDate() === visitDt.getDate();
            });

            
            // what the ???
            if (typeof dt !== "undefined" && dt !== null && dt !== "") {
                if (this.props.routeStepNumber !== 0 && this.state.nextStepCalled === false && !isFromDotCOM) {
                    // if the route is requesting a step other than AppointmentInfo, check the scheduleDays and make sure that the route's date & time are available before switching to the new step.
                    let time = dt.slots.find(s => s.time === this.props.visit.time);
                    if (time && time.time && !isMammography) {
                        this.setState({ nextStepCalled: true }, () => {
                            console.log("calling next");
                            this.props.stepManager.goNext();
                        });
                    }
                }
            } else {
                //debugger;
                //let visit = this.props.visit;
                //visit.date = "";
                //visit.time = "";
                //this.props.saveStepInfo({ visit: visit });
            }
        }
        if (this.isYourDoctorVisitTypeUpdated && this.props.schedule && !this.state.monthChanged) { //update slots if from your doctor visit as we call visittype change in this component.
            const scheduleDays = this.props.schedule ? this.props.schedule.scheduleDays : null;
            if (scheduleDays && scheduleDays.length > 0) {
                if ((!this.isUpdatedAlready || !this.isEqual(this.prevScheduleDays, scheduleDays)) && this.props.routeDate !== scheduleDays[0].date) {
                    const visit = this.props.visit;
                    visit.date = "";
                    visit.time = "";
                    this.props.saveStepInfo({ visit: visit });
                    this.resetShowInValid();
                    this.prevScheduleDays = scheduleDays;
                    this.isUpdatedAlready = true;
                }
                else { this.prevScheduleDays = scheduleDays; }

            }
        }
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    isEqual(prevSchedule, schedule) {
        // if length is not equal 
        if (prevSchedule.length !== schedule.length)
            return false;
        else {
            // comapring first element of array             
            if (prevSchedule[0].date !== schedule[0].date)
                return false;
        }
        return true;
    }

    // per Jake/Jason: when the user selects a new visit type or location, navigate to the earliest date for that type of appointment.
    goToEarliestMonth(visitTypeId, locationId) {
        let earliest = null;
        let visit = this.props.visit;

        // jeez...
        if (this.props.providerDetails && this.props.providerDetails.openSchedule && this.props.providerDetails.openSchedule.dateAndTimes && this.props.providerDetails.openSchedule.dateAndTimes.length > 0) {
            for (var i = 0; i < this.props.providerDetails.openSchedule.dateAndTimes.length; i++) {
                let day = this.props.providerDetails.openSchedule.dateAndTimes[i];
                for (var j = 0; j < day.times.length; j++) {
                    let time = day.times[j];
                    if (time.visitTypeId === visitTypeId && time.departmentId === locationId) {
                        earliest = day;
                        break;
                    }
                }
            }
        }

        if (earliest) {
            const earliestDate = Tools.toJSDate(earliest.date, DATE_FORMAT);
            const endDt = this.getEndDate(earliestDate);
            visit.date = `${earliestDate.getFullYear()}-${earliestDate.getMonth() + 1}-${earliestDate.getDate()}`;
            this.props.saveStepInfo({
                startDate: `${earliestDate.getFullYear()}-${earliestDate.getMonth() + 1}-${earliestDate.getDate()}`,
                endDate: `${endDt.getFullYear()}-${endDt.getMonth() + 1}-${endDt.getDate()}`,
                visit: visit
            });
        }
    }

    handleVisitTypeChange(val) {
        const visit = this.props.visit;
        if (this.props.selectedVisitTypeId !== val) {
            const id = val.split("|")[0];
            const type = val.split("|")[1];
            const visitItem = val && this.props.visitTypes ? this.props.visitTypes.find(item => item.value === val) : undefined;
            visit.visitType.id = id;
            visit.visitType.description = visitItem ? visitItem.label : "";
            visit.visitType.idType = type;
            const readRouteDateTime = this.isYourDoctorVisitTypeUpdated && !this.alreadyReadTheRouteDateTimeForYourDoctorVisit;
            visit.date = readRouteDateTime ? this.props.routeDate ? this.props.routeDate : "" : "";
            visit.time = readRouteDateTime ? this.props.routeTime ? this.props.routeTime : "" : "";
            // visit.visitType.descrption = visitItem.label;
            this.alreadyReadTheRouteDateTimeForYourDoctorVisit = true;
            const loadSchedule = visit.visitType && visit.visitType.id !== "" && visit.department && visit.department.id !== "";
            this.props.saveStepInfo({ val, visitTypeChanged: true, visit: visit }, loadSchedule, false);
            this.resetShowInValid();
        }

        this.goToEarliestMonth(visit.visitType.id, visit.department.id);

        this.checkStepChange(visit);
    }

    handleLocationchange(val) {
        var change = false;
        let visit = this.props.visit;
        const id = val && val.length > 0 ? val.split("|")[0] : "";
        const type = val && val.length > 0 ? val.split("|")[1] : "";
        if (this.props.visit.department && this.props.visit.department.id !== id) {
            change = true;
            if (id && id.length > 0) {
                visit.department.id = id;
                visit.department.idType = type;
                const address = val && this.props.departments ? this.props.departments.find((item) => item.value === val) : undefined;
                if (address) {
                    visit.department.description = address.label;
                    visit.department.address.street1 = address.address1;
                    visit.department.address.street2 = address.address2;
                    visit.department.address.city = address.city;
                    visit.department.address.state = address.state;
                    visit.department.address.zip = address.zip;
                    visit.department.phone = address.phone;
                }
            }
            else {
                visit.department.id = "";
                visit.department.description = "";
                visit.department.idType = "";
                visit.department.address.street1 = "";
                visit.department.address.street2 = "";
                visit.department.address.city = "";
                visit.department.address.state = "";
                visit.department.address.zip = "";
                visit.department.phone = "";
            }
            this.resetShowInValid();
        }
        if (change) {
            const loadSchedule = visit.visitType && visit.visitType.id !== "" && visit.department && visit.department.id !== "";
            this.setState({ visit: visit });
            this.props.saveStepInfo({ locationChanged: true, visit: visit }, loadSchedule, false);
        }

        this.goToEarliestMonth(visit.visitType.id, visit.department.id);

        this.checkStepChange(visit);
    }

    checkStepChange(visit) {
        //if (visit.department.id !== "" && visit.visitType.id !== "" && visit.date !== "" && visit.time !== "") {
        //    this.props.jumpToStep(1);
        //}
    }

    formatSchedule(time) {
        return Tools.formatTimeString(time);
    }

    formatDate(date) {
        // var dt = new Date(date);
        // return dt.toLocaleDateString('en-US', { year: 'numeric', month: 'numeric', day: 'numeric' });
        var dt = Tools.toJSDate(date, Tools.getDateFormats());
        return Tools.getFormattedDate(dt);
    }

    parseDate(strDate) {
        // stupid javascript dates
        if (!strDate) {
            let today = Tools.toJSDate(new Date());
            strDate = Tools.dateSimpleFormat(today);
        }
        const date = Tools.toJSDate(`${strDate} 00:00:00`, DATE_FORMAT);
        return date;
    }

    dateStringCompare(strDt1, strDt2) {
        // stupid, stupid, STUPID javascript dates
        const isSameDate = Tools.isSameDate(strDt1, strDt2);
        return isSameDate;
    }

    containsDate(ar, dt) {
        let ret = false;
        if (ar) {
            for (var i = 0; i < ar.length; i++) {
                const ardt = ar[i];
                if (ardt.getFullYear() === dt.getFullYear() && ardt.getMonth() === dt.getMonth() && ardt.getDate() === dt.getDate()) {
                    ret = true;
                    break;
                }
            }
        }
        return ret;
    }

    requestScheduleByMonth(month, dt) {
        month = this.state.lastSelectedMonth !== -1 && this.state.lastSelectedMonth > dt.getMonth() ? month : month - 1;
        let start = new Date(dt.getFullYear(), month, 1);
        let end = new Date(dt.getFullYear(), month + 1, 0);
        this.props.saveStepInfo({
            startDate: `${start.getFullYear()}-${start.getMonth() + 1}-${start.getDate()}`,
            endDate: `${end.getFullYear()}-${end.getMonth() + 1}-${end.getDate()}`
        }, true, false, false);
    }

    stupidDatePickerHack(dt) {
        // turn a string containing YYYY-MM-DD into one containing MM-DD-YYYY
        if (!dt) {
            let today = Tools.toJSDate(new Date());
            dt = Tools.dateSimpleFormat(today);
        }
        const date = Tools.toJSDate(`${dt} 00:00:00`, DATE_FORMAT);
        let formatedDate = Tools.getSpecificDateFormat(date)
        return formatedDate && formatedDate.length ? formatedDate : null;
        //return parts && parts.length > 1 ? `${(parts[1] + 1).toString().padStart(2, "0")}-${parts[2].toString().padStart(2, "0")}-${parts[0]}` : null;
    }

    getEndDate(dtStart) {
        let dtEnd = new Date(dtStart);
        dtEnd.setDate(1);
        let next = dtEnd.getDate() + 30;
        dtEnd.setDate(next);
        return dtEnd;
    }

    onGoBack(success) {
        if (this.props.isFromVideoVisitOptions) {
            this.props.previousButtonState(true);
        }
    }

    onGoNext(success) {
        if (!success) {
            this.setState({ showAsInvalid: true });
        }
        //call api to load mammogram questions on continue click
        if (this.props.isMammography) {
            this.props.questionsLoaded(true);
            this.loadMammogramQuestions();

            if (this.props.enableNewServiceSchedulingWorkflow && this.props.isFromDotCOM && this.props.patientInfoStepValue && !this.props.hasMyChart){
                this.props.goToNewStep(true, this.props.patientInfoStepValue);
            }
        }
    }

    loadMammogramQuestions = () => {
        this.props.getMammogramQuestions({ visitTypeId: this.props.changedVisitTypeId })
    }

   
    isValid() {
         // Debugger;
        return this.isValidate();
    }

    isValidate() {
        const { validationError } = this.state;
        if (this.props.getScheduleError || this.props.earliestScheduleError) {
            this.setState({ validationError: "Please select an available time." });
            return false;
        }
        else {
            const bValid = this.props.visit && this.props.visit.time !== "" && !this.selectedDayUnavailable && !this.selectedTimeUnavailable;
            if (!bValid) {
                if (validationError !== "Please select an available time.") {
                    this.setState({ validationError: "Please select an available time." });
                }
            }
            else {
                this.setState({ validationError: "" });
            }
            return bValid;
        }
    }

    //Reset the invalid flag.
    resetShowInValid() {
        const { showAsInvalid } = this.state;
        if (this.mounted && showAsInvalid) {
            this.setState({ showAsInvalid: false });
        }
    }

    isFedUp() {
        return this.props.visitTypeAndLocationFailed;
    }

    isVirtualVisit = () => {
        const { serverData, visit } = this.props;
        // As discussed, we need to disable location for all visits present in VideoVisitTypesForLaunchButton config.
        const videoVisitTypesForLaunchButton = serverData && serverData.videoVisitTypesForLaunchButton && serverData.videoVisitTypesForLaunchButton.length > 0 ? serverData.videoVisitTypesForLaunchButton : null;
        const videoVisitTypesForDirectScheduling = serverData && serverData.enableCustomDirectScheduling && disableLocationForVisits ? disableLocationForVisits.split(',') : null;
        let disableLocationForVisits = videoVisitTypesForLaunchButton ? videoVisitTypesForLaunchButton + "," : null;
        return visit && visit.visitType && visit.visitType.id && videoVisitTypesForDirectScheduling && videoVisitTypesForDirectScheduling.indexOf(visit.visitType.id) !== -1;
    }

    onToggleButton = () => {
        if (this.state.isTwoDVisible) {
            this.handleVisitTypeChange(window.serverData.data.mammography3DVisitTypeId);
            this.props.visitTypeCallback(window.serverData.data.mammography3DVisitTypeId);
        } else {
            this.handleVisitTypeChange(window.serverData.data.mammographyVisitTypeId);
            this.props.visitTypeCallback(window.serverData.data.mammographyVisitTypeId);

        }
        this.setState({
            isTwoDVisible: !this.state.isTwoDVisible
        })
    }

    getVisitTypeIdSpecificTimeSlots(scheduleDays) {
        let twoDSlots = [];
        let threeDSlots = [];
        if (this.state.isTwoDVisible) {
            for (let count = 0; count < scheduleDays.length; count++) {
                if (scheduleDays[count].visitType.id === window.serverData.data.mammographyVisitTypeId) {
                    twoDSlots.push(scheduleDays[count]);
                }
            }
            scheduleDays = twoDSlots;
        } else {
            for (let count = 0; count < scheduleDays.length; count++) {
                if (scheduleDays[count].visitType.id === window.serverData.data.mammography3DVisitTypeId) {
                    threeDSlots.push(scheduleDays[count]);
                }
            }
            scheduleDays = threeDSlots;
        }
        return scheduleDays;
    }

    render() {
        const { visit, schedule, visitTypeDisplayName, changedVisitTypeId, isMammography, serverData, scheduleDaysAvailable, providerSearchModel, isFromVideoVisitOptions, isDisableSelectVisitAndDepartOption, isDirectVisit
} = this.props;
        const { validationError, showAsInvalid, canShowTogglebutton } = this.state;
        let scheduleDays = schedule ? schedule.scheduleDays : null;
        if (this.props.visitTypes.length > 1 && isMammography) {
            this.threeDSlot = this.props.visitTypes[1].value.trim(' ');
            this.twoDSlot = this.props.visitTypes[0].value.trim(' ');
        }
        if (isMammography && this.state.twoDstate.length > 1 && this.state.threeDstate.length > 1 && schedule && schedule.scheduleDays) {
            scheduleDays = this.getVisitTypeIdSpecificTimeSlots(schedule.scheduleDays);
        }
        // calendar items...
        const calendarSlots = scheduleDays && scheduleDays.length > 0 ? scheduleDays.map((slot, i) => { return slot.date; }) : [];
        const selectedDays = scheduleDays && scheduleDays.length > 0 ? scheduleDays.map((slot, i) => { return this.parseDate(slot.date); }) : [];
        let selectedDate = "", selectedTime = "", visitTypeName = "";
        if (visit) {
            selectedDate = visit.date;
            // if (!selectedDate || selectedDate === "") {
            //  selectedDate = this.props.routeDate;
            //}
            selectedTime = visit.time;
            visitTypeName = visit.visitType && visit.visitType.description;
        }
        this.selectedDayUnavailable = false;
        if (scheduleDaysAvailable === false) {
            this.selectedDayUnavailable = true;
        }
        else if (selectedDate && this.props.schedule && this.props.schedule.scheduleDays) {
            const ar = this.props.schedule.scheduleDays.filter((item) => this.dateStringCompare(item.date, selectedDate));
            if (isMammography && changedVisitTypeId.length && canShowTogglebutton) {
                this.selectedDayUnavailable = !ar.some((item) => item.visitType.id === this.props.changedVisitTypeId);
            } else {
                this.selectedDayUnavailable = ar.length <= 0 ? true : false;
            }
        }

         //stupid logic
         if (this.props.isFromDotCOM && this.selectedDayUnavailable) {
            selectedDays.push(this.parseDate(visit.date))
        }

        let findcareSearchParms = null;
        if (providerSearchModel) {
            findcareSearchParms = "?" + queryParams({
                keyword: providerSearchModel.keyword ? providerSearchModel.keyword : '',
                vector: providerSearchModel.vectorName ? providerSearchModel.vectorName : '',
                visitType: visitTypeName,
                userlocation: providerSearchModel.Location ? providerSearchModel.Location : '',
                state: "scheduling"
            });
        }

        // buttons...
        let buttonSlots = [];
        let calSelectedDay = null;
        // calendar data available, highlight either the date the user selected or the first available date...
        if (scheduleDays && scheduleDays.length > 0) {
            let dtVisit = Tools.toJSDate(`${visit.date} 00:00:00`, DATE_FORMAT);
            let dtSched = Tools.toJSDate(`${scheduleDays[0].date} 00:00:00`, DATE_FORMAT);
            let selDay = selectedDate !== "" ? Tools.toJSDate(`${selectedDate} 00:00:00`, DATE_FORMAT) : new Date();
            let dtStart = this.props.startDate !== "" ? Tools.toJSDate(`${this.props.startDate} 00:00:00`, DATE_FORMAT) : new Date();
            let dtStr = visit.date;
            if (visit.date !== "") {
                calSelectedDay = dtVisit;
            }
            else if (dtSched) {
                calSelectedDay = dtSched;
                dtStr = `${dtSched.getFullYear()}-${(dtSched.getMonth() + 1).toString().padStart(2, '0')}-${dtSched.getDate().toString().padStart(2, '0')}`;
            }
            else if (this.props.routeDate) {
                calSelectedDay = Tools.toJSDate(this.props.routeDate, DATE_FORMAT);
            }
            else {
                calSelectedDay = Tools.toJSDate(`${selectedDate} 00:00:00`, DATE_FORMAT);
                dtStr = `${selectedDate} 00:00:00`;
                calSelectedDay.setDate(1);
            }

            // one last check: if the selected day is not in the dates returned by the api, select the first available date
            if (calendarSlots && calendarSlots.length > 0) {
                let formatted = Tools.dateSimpleFormat(calSelectedDay);
                let isInList = calendarSlots.filter((day, i) => day === formatted).length > 0;
                if (!isInList && !(this.props.isFromDotCOM && (this.props.enableNewProviderSchedulingWorkflow || (isMammography && this.props.enableNewServiceSchedulingWorkflow)) )) {
                    calSelectedDay = Tools.toJSDate(calendarSlots[0], DATE_FORMAT);
                }
            }
        }

        // default selections: props received but no selection has been made...default to the first item in each list.
        if (this.props.visit && this.props.visit.department && this.props.visit.department.id === "" && this.props.visit && this.props.visit.visitType && this.props.visit.visitType.id === "" &&
            this.props.visitTypes.length > 0 && this.props.departments.length > 0) {
            this.handleVisitTypeChange(this.props.visitTypes[0].value);
            this.handleLocationchange(this.props.departments[0].value);
        }

        this.selectedTimeUnavailable = false;
        if (selectedDate && selectedDate !== "") {
            if (scheduleDays && scheduleDays.length >= 0) {
                //let dt = this.parseDate(selectedDate);
                let dt = Tools.toJSDate(selectedDate, DATE_FORMAT);
                 for (var i = 0; i < scheduleDays.length; i++) {
                    let scheduleDay = [];
                    if (isMammography && scheduleDays[i].slots.length) {
                        scheduleDay = scheduleDays[i];
                    } else if (!isMammography){
                        scheduleDay = scheduleDays[i];
                    }
                    //const scheduleDay = scheduleDays[i];
                    const schedDate = this.parseDate(scheduleDay.date);
                    if (this.state.monthChanged === false) {
                        if (this.props.routeDate && this.props.routeDate === selectedDate) {
                            if (this.props.routeTime === undefined || this.props.routeTime === null || this.props.routeTime === "") {
                                this.selectedTimeUnavailable = false;
                            }
                            else if (this.props.visitTypeChanged === false && this.props.locationChanged === false && scheduleDay.date === this.props.routeDate && this.props.routeDate && this.props.isFromDotCOM && (this.props.enableNewProviderSchedulingWorkflow || (isMammography && this.props.enableNewServiceSchedulingWorkflow))) {
                                // don't show the "selected time unavailable" error if the drop downs have changed...
                                this.selectedTimeUnavailable = scheduleDay.slots.filter((day) => day.time === selectedTime || day.time === this.props.routeTime).length === 0;
                            }
                        }
                    }

                    if (dt.getFullYear() === schedDate.getFullYear() && dt.getMonth() === schedDate.getMonth() && dt.getDate() === schedDate.getDate()) {
                        let bMatched = false;
                        //let checkedIdx = 0;
                        //for (var idx = 0; idx < scheduleDay.slots.length; idx++) {
                        //    if (scheduleDay.slots[idx].time === selectedTime) {
                        //        checkedIdx = idx;
                        //        break;
                        //    }
                        //}
                        buttonSlots = scheduleDay && scheduleDay.slots && scheduleDay.slots.map((slot, i) => {
                          if (slot.time === selectedTime) {
                                bMatched = true;
                            }
                            return <label className="appt-btn-container" key={i} onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                this.props.saveSlot(slot.time, slot.duration);
                                if (!this.timeSelected) {
                                    this.timeSelected = true;
                                    if (this.props.isValid) {
                                        this.props.isValid(true);
                                    }
                                    this.isValidate();
                                }
                            }}>
                                <input type="radio" id={`${scheduleDay.date}|${slot.time}`} name="timesRadioGroup" defaultChecked={slot.time === selectedTime} />
                                <div className="btn btn-primary">{this.formatSchedule(slot.time)}</div>
                            </label>;
                        });
                        if (!bMatched) {
                            this.timeSelected = false;
                            if (selectedTime !== "") {
                                this.props.saveSlot("");
                            }
                        }
                    }
                }
            }
        }

        let showButtonSlots = calendarSlots.length > 0 && buttonSlots.length > 0 && this.props.visit.date !== "" && !this.props.waiting;
        // error message text
        let errorTime = "The selected time is not available.";
        let errorTimeAnchor = "see more doctors with availability.";
        let errorDate = "The selected date is not available.";
        let errorDateAnchor = "see more doctors with availability.";
        let errorNoAvailability = isMammography ? "" : `There is no availability for the selected visit type${(this.props.departments && this.props.departments.length > 1) ? ' for the selected location' : ''} this month.`;
        let errorNoAvailabilityAnchor = isMammography ? "" : "See more doctors with availability.";
        let appendVisit = visitTypeName && visitTypeName.toLowerCase().indexOf("visit") >= 0 ? "" : " visit";
        let appendVisitName = visit.name
        //let mammoVisit = this.props.visitTypes && this.props.visitTypes.length && this.props.visitTypes[0] && this.props.visitTypes[0].label;
        let errorToShow = "";
        let selectedDateUnavailable = false;

        //Show error for if selected date is unavailable:
        if (this.props.startDate && this.props.routeDate && this.props.startDate === this.props.routeDate && calendarSlots && calendarSlots.length > 0) {
            const containsStartDate = calendarSlots.filter((slot, i) => Tools.isSameDate(slot, this.props.startDate)).length > 0;
            if (!containsStartDate) selectedDateUnavailable = true;
        }

        if ((this.selectedDayUnavailable === true || scheduleDaysAvailable === false) && !(this.props.enableNewProviderSchedulingWorkflow && this.props.isFromDotCOM)) {
            errorToShow = "errorNoAvailability";
            // let monthName = "";
            if (this.props.startDate) {
                let sDate = Tools.toJSDate(`${this.props.startDate} 00:00:00`, DATE_FORMAT);
                let displayMonth = '' + (sDate.getMonth() + 1);
                if (displayMonth.length < 2) displayMonth = '0' + displayMonth;
                this.monthName = Tools.getMonthFullName(displayMonth);
            }
            //Show this error msg for if selected month slots was unavailable in open Scheduling & Direct Scheduling 
            if (!this.props.getScheduleError && visitTypeName !== "" && !isMammography) {
                errorNoAvailabilityAnchor = `See more doctors with availability for a ${visitTypeName}${appendVisit}.`;
               // errorNoAvailability = `There is no availability for a ${visitTypeName} ${appendVisit} in ${this.monthName ? this.monthName : 'this month'}.`;
                errorNoAvailability = `There is no availability in ${this.monthName ? this.monthName : 'this month'}.Please use the arrow to check the next month.`
            }
            else {
                //adding IF condition so that we can display below error msg only when we have visitTypeDisplayName (2D/3D)
                if (visitTypeDisplayName && visitTypeDisplayName.length > 1 && !this.props.canShowFirstAvailableSlot) {
                    errorNoAvailability = `There is no availability for ${visitTypeDisplayName && visitTypeDisplayName.length > 1 ? visitTypeDisplayName[0].replace('d', 'D') : ""} visit in ${this.monthName ? this.monthName : 'this month'}.`;
                    errorNoAvailabilityAnchor = `See more locations with availability for a ${visitTypeDisplayName && visitTypeDisplayName.length > 1 ? visitTypeDisplayName[0].replace('d', 'D') : ""} visit.`
                }
            }
            if (selectedDateUnavailable) {
                errorToShow = "errorDate";
                errorDate = `${selectedDate !== "" ? selectedDate : "The selected date"} is not available for a ${get(this.props, 'schedule.visitTypes[0].name', '')} ${appendVisit}.`;
                errorDateAnchor = `see more locations with availability for a ${get(this.props, 'schedule.visitTypes[0].name', '')} ${appendVisit}.`;
            }
        }
        else if (this.selectedTimeUnavailable === true) {
            errorToShow = "errorTime";
            errorTime = `${selectedTime !== "" ? selectedTime : "The selected time"} is not available for a ${get(this.props, 'schedule.visitTypes[0].name', '')} ${appendVisit}.`;
            errorTimeAnchor = `see more locations with availability for a ${get(this.props, 'schedule.visitTypes[0].name', '')} ${appendVisit}.`;
        } else if (selectedDateUnavailable) {
            errorToShow = "errorDate";
            errorDate = `${selectedDate !== "" ? selectedDate : "The selected date"} is not available for a ${get(this.props, 'schedule.visitTypes[0].name', '')} ${appendVisit}.`;
            errorDateAnchor = `see more locations with availability for a ${get(this.props, 'schedule.visitTypes[0].name', '')} ${appendVisit}.`;
        }
        //let mamoError = `There is no availability for ${visitTypeDisplayName && visitTypeDisplayName.length > 1 ? visitTypeDisplayName[0].replace('d', 'D') : ""} visit in ${this.monthName ? this.monthName : 'this month'}.`;
        //let mamoLink = `See more locations with availability for a ${visitTypeDisplayName && visitTypeDisplayName.length > 1 ? visitTypeDisplayName[0].replace('d', 'D') : ""} visit.`;
        //else if (calendarSlots.length <= 0 && buttonSlots.length <= 0) {
        //    let monthName = "";
        //    if (this.props.startDate) {
        //        let sDate = Tools.toJSDate(`${this.props.startDate} 00:00:00`, DATE_FORMAT);
        //        let displayMonth = '' + (sDate.getMonth() + 1);
        //        if (displayMonth.length < 2) displayMonth = '0' + displayMonth;
        //        monthName = Tools.getMonthFullName(displayMonth);
        //    }
        //    if (!this.props.getScheduleError && visitTypeName !== "") {
        //        errorToShow = "errorNoAvailability";
        //        errorNoAvailability = `There is no availability for a ${visitTypeName} visit in ${monthName ? monthName : 'this month'}.`;
        //        errorNoAvailabilityAnchor = `See more doctors with availability for a ${visitTypeName}${appendVisit}.`;
        //    } 
        //}
        let calInitialDate = new Date();
        if (calendarSlots && calendarSlots.length > 0 && !selectedDateUnavailable) {
            const containsStart = calendarSlots.filter((slot, i) => Tools.isSameDate(slot, this.props.visit.date) || slot === this.props.routeDate).length > 0;
            if (containsStart) {
                calInitialDate = Tools.toJSDate(this.props.visit.date, DATE_FORMAT);
            }
            else if((this.state.monthChanged) || (!((this.props.enableNewProviderSchedulingWorkflow || (isMammography && this.props.enableNewServiceSchedulingWorkflow)) && this.props.isFromDotCOM))) {
                calInitialDate = Tools.toJSDate(calendarSlots[0], DATE_FORMAT);
            }
               
            selectedDate = Tools.dateSimpleFormat(calInitialDate);
            buttonSlots = [];
            if (selectedDate && selectedDate !== "") {
                if (scheduleDays && scheduleDays.length >= 0) {
                    let dt = Tools.toJSDate(selectedDate, DATE_FORMAT);
                    for (var i = 0; i < scheduleDays.length; i++) {
                        const scheduleDay = scheduleDays[i];
                        const schedDate = this.parseDate(scheduleDay.date);
                        if (this.state.monthChanged === false) {
                            if (this.props.routeDate && this.props.routeDate === selectedDate) {
                                if (this.props.routeTime === undefined || this.props.routeTime === null || this.props.routeTime === "") {
                                    this.selectedTimeUnavailable = false;
                                }
                                else if (this.props.visitTypeChanged === false && this.props.locationChanged === false && scheduleDay.date === this.props.routeDate && this.props.routeDate && this.props.isFromDotCOM && (this.props.enableNewProviderSchedulingWorkflow || (isMammography && this.props.enableNewServiceSchedulingWorkflow))) {
                                 this.selectedTimeUnavailable = scheduleDay.slots.filter((day) => day.time === selectedTime || day.time === this.props.routeTime).length === 0;
                                }
                            }
                        }
                        if (dt.getFullYear() === schedDate.getFullYear() && dt.getMonth() === schedDate.getMonth() && dt.getDate() === schedDate.getDate()) {
                            let bMatched = false;
                            buttonSlots = scheduleDay.slots.map((slot, i) => {
                                if (slot.time === selectedTime) {
                                    bMatched = true;
                                    if (this.isYourDoctorVisitTypeUpdated && !this.timeSelected) {
                                        this.props.saveSlot(slot.time, slot.duration);
                                        this.timeSelected = true;
                                        if (this.props.isValid) {
                                            this.props.isValid(true);
                                        }
                                        this.isValidate();
                                    }
                                }
                                return <label className="appt-btn-container" key={i} onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    this.props.saveSlot(slot.time, slot.duration);
                                    if (!this.timeSelected) {
                                        this.timeSelected = true;
                                        if (this.props.isValid) {
                                            this.props.isValid(true);
                                        }
                                        this.isValidate();
                                    }
                                }}>
                                    <input type="radio" id={`${scheduleDay.date}|${slot.time}`} name="timesRadioGroup" defaultChecked={slot.time === selectedTime} />
                                    <div className="btn btn-primary">{this.formatSchedule(slot.time)}</div>
                                </label>;
                            });
                            if (!bMatched) {
                                this.timeSelected = false;
                                if (selectedTime !== "") {
                                    this.props.saveSlot("");
                                }
                            }
                        }
                    }
                }
            }
            showButtonSlots = calendarSlots.length > 0 && buttonSlots.length > 0 && this.props.visit.date !== "" && !this.props.waiting;
            const selectedDayForFirstSlot = this.props.schedule.scheduleDays.filter((item) => this.dateStringCompare(item.date, selectedDate));
            if (isMammography && changedVisitTypeId.length && canShowTogglebutton) {
                this.selectedDayUnavailable = !selectedDayForFirstSlot.some((item) => item.visitType.id === this.props.changedVisitTypeId);
            } else {
                this.selectedDayUnavailable = selectedDayForFirstSlot.length <= 0 ? true : false;
            }

        }
        else {
            calInitialDate = Tools.toJSDate(this.props.startDate, DATE_FORMAT);
            if (selectedDateUnavailable) {
                selectedDate = Tools.dateSimpleFormat(this.props.startDate);
            }
        }
        let calMinDate = new Date();
       //if (this.props.routeDate) {
         //   calMinDate = Tools.toJSDate(this.props.routeDate);
        //}
        //let calMinDate = Tools.toJSDate(calInitialDate);
        //if (calMinDate) calMinDate.setDate(1);

        //Disable earliest schedule call. Becuase its not needed as per api team discussion.
        //if (earliestSchedule && earliestSchedule.scheduleDays && earliestSchedule.scheduleDays.length > 0) {
        //    calMinDate = Tools.toJSDate(earliestSchedule.scheduleDays[0].date, DATE_FORMAT);
        //}
        let selectedVisitTypes = this.props.visitTypes.filter((v) => { return v.value.indexOf(this.props.visit && this.props.visit.visitType && this.props.visit.visitType.id >= 0); });
        let selectedVisitType = selectedVisitTypes && selectedVisitTypes.length > 0 ? selectedVisitTypes[0] : this.props.visitTypes[0];
        const divStyle = { minHeight: '400px' };
        const isVirtualVisit = this.isVirtualVisit();
        const visitName = startCase(get(this.props, 'schedule.visitTypes[0].name', '').toLowerCase());
        const { label, label2 } = this.props.departments[0] || {};
        const navigateToFindCare = () => {
            let findcareSearchParms = "?" + queryParams({ keyword: "mammography", tab: 2, isChangeLocation: true });
            this.props.history.push({
                pathname: '/findcare',
                search: findcareSearchParms
            });
        }
        const errCondition = this.props.showErrors === true && this.props.searchRunning === false && this.selectedTimeUnavailable === true;
       return (
            <div style={this.props.style}>
                {
                    this.props.visitTypeAndLocationFailed === true &&
                    <OpenSchedulingError apiMessage="We're sorry, scheduling for this doctor is temporarily unavailable." />
                }
                {
                    this.props.visitTypeAndLocationFailed === false &&
                    <div className="schedule-appointment-info-container" >
                        <div className="row">
                            <div className="col-12">
                                {
                                    selectedDate !== "" && selectedTime !== "" && !isMammography &&
                                    <h1 className="step-heading">Let's confirm: do these details look correct?</h1>
                                }
                                {
                                    (selectedTime === "" || isMammography) &&
                                    <h1 className="step-heading  my-4">When would you like to schedule this appointment?</h1>
                                }
                                {
                                    isMammography && this.props.departments.length && visitTypeDisplayName.length ?
                                        <p className="mammography-subheading">{visitTypeDisplayName || label || label2 ? `${visitTypeDisplayName && visitTypeDisplayName.length > 1 ? visitTypeDisplayName[1] : ""} | ${label ? label : ''} | ${label2 ? label2 : ''}` : ""}</p>
                                        : <p className="mammography-subheading"></p>
                                }
                                {serverData && serverData.covidVideoSchedulingEnabled === true &&
                                    <p className="step-description">In-person online scheduling options are temporarily suspended due to COVID-19</p>
                                }
                            </div>
                        </div>
                           {((this.props.visitTypes && this.props.departments) && (isFromVideoVisitOptions || isDirectVisit)) &&  
                            <div className="row minimal-style">
                                <div className="col-12 col-md-4 form-group">
                                    <MultiLineSelect name="visitType" placeholder={"Appointment Type"}
                                        value={`${this.props.visit.visitType.id}|${this.props.visit.visitType.idType}`} options={this.props.visitTypes} required disableEmptyOption
                                        onChange={(e, value) => this.handleVisitTypeChange(value)}
                                        disabled={isDisableSelectVisitAndDepartOption || isVirtualVisit || (typeof isFromVideoVisitOptions !== 'undefined' && isFromVideoVisitOptions) || !this.props.visitTypes || this.props.visitTypes.length <= 1}
                                        id="schedule-visit-type"
                                    />
                                </div>
                                <div className="col-12 col-md-8 form-group">
                                    <MultiLineSelect name="location" placeholder="Location"
                                           value={`${this.props.visit.department && this.props.visit.department.id}|${this.props.visit.department && this.props.visit.department.idType}`} options={isVirtualVisit ? [] : this.props.departments} required disableEmptyOption
                                        onChange={(e, value) => this.handleLocationchange(value)}
                                        disabled={isDisableSelectVisitAndDepartOption || isVirtualVisit || !this.props.departments || this.props.departments.length <= 1}
                                        id="schedule-location"
                                        // dontShowNotEmpty={isVirtualVisit}
                                    />
                                </div>
                            </div>
                        }

                        {isMammography && <div className="toggle-container">
                            {this.state.twoDstate.length > 1 && this.state.threeDstate.length > 1 ?
                                <div className="toggle-and-text">
                                    <div className="toggle-sub-container">
                                        <span className={this.state.isTwoDVisible ? "TwoD-Screen-selected" : "TwoD-Screen-unselected"}>{"2D Screen"}</span>
                                        {<label className="switch">
                                            <input type="checkbox" onChange={this.onToggleButton} checked={!this.state.isTwoDVisible} />
                                            <span className="slider round"></span>
                                        </label>}
                                        <span className={!this.state.isTwoDVisible ? "ThreeD-Screen-selected" : "ThreeD-Screen-unselected"}>{"3D Screen"}</span>
                                    </div>
                                    <div className="text-button">
                                        {"We show 3D screening mammogram availability by default. If you prefer a 2D screening mammogram, change this selection."}
                                    </div>
                                </div> :
                                this.state.twoDstate.length > 1 ?
                                    <div className="screen-text-align"> <span className="Only-2D">{"2D Screen"}</span><span className="D-text">{"This facility only offers 2D screenings. If you prefer to have a 3D screening please select a different location."}</span></div>
                                    :
                                    <div><span className="Only-3D">{"3D Screen"}</span><span className="D-text">{"If you prefer a 2D screening please let the facility know when you arrive for your appointment."}</span></div>
                            }
                        </div>
                        }
                        {
                            <div className="row schedule-container">
                                <div className="col-12 col-md-6" id="schedule-calendar">
                                    <DatePicker
                                        /*selectedDays={selectedDays}*/
                                        initialDate={calInitialDate}
                                        /*maxDate={isMammography ? moment().add(6, 'months').toDate() : undefined}*/
                                        minDate={calMinDate}
                                        value={this.stupidDatePickerHack(selectedDate)}
                                        isInline
                                        onClick={(day) => {
                                            if (this.containsDate(selectedDays, day)) {
                                                let visit = this.props.visit;
                                                //visit.date = `${day.getFullYear()}-${day.getMonth() + 1}-${day.getDate()}`;
                                                visit.date = Tools.dateSimpleFormat(day);
                                                visit.time = "";
                                                this.props.saveStepInfo({ visit: visit });
                                                this.resetShowInValid();
                                            }
                                        }}
                                        onMonthChange={(dt) => {
                                            let visit = this.props.visit;
                                            visit.date = "";
                                            visit.visitType.startDate = '';
                                            visit.visitType.endDate = '';
                                            visit.time = "";
                                            this.setState({ visit: visit, monthChanged: true });
                                            this.requestScheduleByMonth(this.state.lastSelectedMonth !== -1 && this.state.lastSelectedMonth > dt.getMonth() ? dt.getMonth() : dt.getMonth() + 1, dt);
                                            this.setState({ lastSelectedMonth: dt.getMonth() });
                                            this.resetShowInValid();
                                        }}
                                        disabled={calendarSlots.length < 1}
                                        enabledDays={selectedDays}
                                        selectedDays={errorToShow !== "errorDate" ? calSelectedDay : ((this.props.enableNewProviderSchedulingWorkflow || (isMammography && this.props.enableNewServiceSchedulingWorkflow)) && this.props.isFromDotCOM) ? calSelectedDay : null}
                                        //selectedDays={errorToShow !== "errorDate" ? calSelectedDay : null}
                                    />
                                    <div className="appointment-emergency-info">
                                        If this is an emergency, please contact 911.
                                    </div>
                                </div>
                                <div className="col-12 col-md-6 schedule-time-slots-container">
                                    {/* below message will show when api fails  */}
                                    { (this.props.visitTypeAndLocationPending || this.props.providerSchedulePending) &&
                                         <React.Fragment>
                                            <Spinner />
                                         </React.Fragment>
                                    }
                                    {(!isMammography && (this.props.getScheduleError || this.props.earliestScheduleError)) || (isMammography && (this.props.getScheduleError || this.props.earliestScheduleError) && this.props.providerData === null)
                                        ? <div className="not-available-msg">We are not able to display times for this appointment type and location. Please try again later.</div>
                                        :  <>{(this.props.waiting) &&
                                            <div className="row overlay-loading-container">
                                                <div className="col-12 align-self-center">
                                                    <MiniSpinner />
                                                </div>
                                            </div>
                                        }</>
                                    }

                                    {/* error "time not available": visit, department, date and time selected; time is not available... */}
                                    {errCondition && (errorToShow === "errorTime") &&
                                        <div className="not-available-msg">
                                            {errorTime} Please choose another time or <Link to={{ pathname: '/findcare', search: findcareSearchParms }}>{errorTimeAnchor}</Link>
                                        </div>
                                    }

                                    {this.props.isFromDotCOM && this.selectedDayUnavailable && (this.props.enableNewProviderSchedulingWorkflow || (isMammography && this.props.enableNewServiceSchedulingWorkflow)) &&
                                    scheduleDays && scheduleDays.length > 0 &&
                                        <div className="not-available-msg">
                                            {"The selected date is not available. Please choose another date"}
                                        </div>
                                    }


                                    {errCondition && (errorToShow === "errorDate") &&
                                        <div className="not-available-msg">
                                            {errorDate} Please choose another date or <Link to={{ pathname: '/findcare', search: findcareSearchParms }}>{errorDateAnchor}</Link>
                                        </div>
                                    }
                                                                        
                                    { /* error "no availability": visit and department selected; no calendar data returned... */ }
                                    { /* error "no availability": visit and department selected; no calendar data returned... Mammogram workflow*/ }
                                    {(this.props.scheduleDaysAvailable === false || (this.props.showErrors === true && errorToShow === "errorNoAvailability" && (this.props.searchRunning === false && calendarSlots.length <= 0 && buttonSlots.length <= 0 && !this.props.providerScheduleSuccessStatus))) &&
                                        <div className="not-available-msg">
                                               { errorNoAvailability } <p>{isMammography ? <Link to={{ pathname: '/findcare', search: "?" + queryParams({ keyword: "mammography", tab: 2 }) }} >{errorNoAvailabilityAnchor}</Link> : ""} </p>
                                        </div>
                                    }
                                    {/* {//jason going in here
                                        // error "no availability": visit and department selected; no calendar data returned...
                                        (this.props.scheduleDaysAvailable === false || (this.props.showErrors === true && errorToShow === "errorNoAvailability" && (this.props.searchRunning === false && calendarSlots.length <= 0 && buttonSlots.length <= 0 && !this.props.providerScheduleSuccessStatus))) && !isMammography &&

                                        <div className="not-available-msg">
                                            {errorNoAvailability} <Link to={{ pathname: '/findcare', search: findcareSearchParms }}>{errorNoAvailabilityAnchor}</Link>
                                        </div>
                                    } */}
                                    {/* {
                                        // error "no availability": visit and department selected; no calendar data returned... Mammogram workflow
                                        (this.props.scheduleDaysAvailable === false || (this.props.showErrors === true && errorToShow === "errorNoAvailability" && (this.props.searchRunning === false && calendarSlots.length <= 0 && buttonSlots.length <= 0 && !this.props.providerScheduleSuccessStatus))) && isMammography &&
                                        <div className="not-available-msg">
                                            {errorNoAvailability} <p><Link to={{ pathname: '/findcare', search: "?" + queryParams({ keyword: "mammography", tab: 2 }) }} >{errorNoAvailabilityAnchor}</Link></p>
                                        </div>
                                    } */}
                                    {/*
                                        this.props.getScheduleError === true &&
                                        <div className="not-available-msg">
                                            {errorNoAvailability} <Link to={{ pathname: '/findcare', searchParms: findcareSearchParms }}>{errorNoAvailabilityAnchor}</Link>
                                        </div>
                                    */}
                                    {(!this.props.getScheduleError && !this.props.earliestScheduleError) &&
                                        <> {showButtonSlots
                                            && <div className="schedule-time-slots" role="radiogroup" aria-label="Available appointment times">
                                                {buttonSlots}
                                            </div>
                                            // : (this.props.scheduleDaysAvailable === false || (this.props.showErrors === true && errorToShow != "errorNoAvailability" && (this.props.searchRunning === false && calendarSlots.length <= 0 && buttonSlots.length <= 0 && !this.props.providerScheduleSuccessStatus)))
                                            //    &&
                                            //     //errorToShow === "errorNoAvailability" ? "" : (this.props.waiting) && <div className="not-available-msg">{mamoError} <Link to={{ pathname: '/findcare', search: findcareSearchParms }}><span>{mamoLink}</span></Link></div>
                                            //     <div className="row overlay-loading-container">
                                            //         <div className="col-12 align-self-center">
                                            //             <MiniSpinner/>
                                            //        </div>
                                            // </div>
                                        }
                                        </>
                                    }
                                </div>
                            </div>
                        }
                        {isMammography &&
                            <div className="row">
                                <div className="col-12 col-md-6">
                                    <div className="change-location-container footer-buttons">
                                        <button className="btn btn-primary" onClick={navigateToFindCare}>Change Location</button>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                }
                {(showAsInvalid && validationError !== "") &&
                    <div className="text-center validation-error-container">
                        <div className="error-msg">{validationError}</div>
                    </div>
                }
                {(typeof isFromVideoVisitOptions !== 'undefined' && isFromVideoVisitOptions) && <div class="hr-divider"></div>}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        scheduleDaysAvailable: state.openScheduling.scheduleDaysAvailable,
        mammogramQuestions: state.openScheduling.mammogramQuestions,

    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        getMammogramQuestions: (QuestionsSearchModel) => {
            dispatch({ type: types.OPEN_SCHEDULE_MAMMOGRAM_QUESTIONS, searchModel: QuestionsSearchModel });
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(AppointmentInfo);